import { getDBTimestampFromDate } from './getDBTimestampFromDate';

export function getLocaleTimestamp(timestamp) {
	if (timestamp.length === 8) {
		timestamp = timestamp + " 00:00";
	}
	const year = timestamp.substring(0, 4);
	const month = timestamp.substring(4, 6);
	const day = timestamp.substring(6, 8);
	const hours = timestamp.substring(9, 11);
	const minutes = timestamp.substring(12, 14);
	
    const date = new Date();
	date.setUTCFullYear(year);
	date.setUTCMonth(parseInt(month, 10) - 1, parseInt(day, 10));
	date.setUTCHours(parseInt(hours, 10));
	date.setUTCMinutes(parseInt(minutes, 10));
	
	return getDBTimestampFromDate(date);
}
